export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg class="'+(props.styles.animatedIcon)+'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14"> <g fill="none" fill-rule="evenodd"> <path fill="#FFF" d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/> <path stroke="#FFF" d="M9.853 10.837a5.45 5.45 0 0 0 0-7.707"/> </g> </svg></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/interaction-indicator/templates/decreaseVolumeIcon.dot
// module id = 145
// module chunks = 0 1 2 3 4